import { render, staticRenderFns } from "./storeroomupdate.vue?vue&type=template&id=19fba0b4&"
import script from "./storeroomupdate.vue?vue&type=script&lang=js&"
export * from "./storeroomupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports